import React, { useState, useRef } from "react";
import { Box } from "@material-ui/core";
import { GetFilterJobSeeker, GetSavedFilters, DeleteSavedFilter } from './api'
import { useSelector, shallowEqual } from 'react-redux'
import { NavLink, useHistory  } from 'react-router-dom'
import { useEffect } from "react";
import moment from 'moment'


const ReportingOverview = () => {
  const [show,setShow]=useState(true)

  const history = useHistory();
  
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [pending, setPending] = useState(false)

  const [savedFilter, setSavedFilter] = useState([]);

  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(false)
  const [searchPending, setSearchPending] = useState(false);

  useEffect(()=>{
    handleGetSavedFilter();
  }, [])

  useEffect(()=>{
    (async function(){
      setSearchPending(true)
      try{
        let res = await GetSavedFilters(user.id, search);
        setSavedFilter(res.filters)
        if(res.filters.length == 0 && search == ''){
          setSearching(false);
        }
      }catch(ex){
        console.log(ex);
      }finally{
        setSearchPending(false)
      }
    })();
  }, [search])


  const handleGetSavedFilter = async ()=> {
    setPending(true)
    try{
      let res = await GetSavedFilters(user.id, search);
      setSavedFilter(res.filters)
      if(res.filters.length > 0){
        setSearching(true)
      }
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false)
    }
  }

  const handleDeleteSavedFilter = async (filter) => {
    try{
      const res = await DeleteSavedFilter(filter._id);
      (async function(){
        setSearchPending(true)
        try{
          let res = await GetSavedFilters(user.id, search);
          setSavedFilter(res.filters)
          if(res.filters.length == 0 && search == ''){
            setSearching(false);
          }
        }catch(ex){
          console.log(ex);
        }finally{
          setSearchPending(false)
        }
      })();
      // handleGetSavedFilter()
    }catch(ex){
      console.log(ex);
    }
  }

  return (
    <Box>
      <div className="">
        <div className=" d-flex flex-column">
          {/* <h1 className="pb-5">Report</h1> */}
          <div className="">
          <div className=" d-flex py-3">
              {/* <RiFilter2Fill className="font hover" onClick={()=>setShow(false)}/ >
              <p className=" text-black font-weight-bold font1 mt-2">Filters</p>
              <p className="color mt-3 pl-5 ml-5">{ savedFilter }</p> */}
            </div>
            <div className=" py-5">

            {/* <button className=" rounded clr">Resume <RxCross2 className="clr"/></button>
            <button className="ml-3  rounded clr">Cover letter <RxCross2 className="clr"/></button>
            <button className="ml-3 y rounded clr ">Occupation <RxCross2 className="clr"/></button>
            <button className="ml-3  rounded clr">Linkedin <RxCross2 className="clr"/></button>
            <button className="ml-3 rounded clr">1–16 Dec 2022 <RxCross2 className="clr"/></button>
            <button className="ml-3 bg-transparent border-0 text1">Clear All</button> */}
          
            </div>
              </div>
        </div>
        {pending && <div className="w-100 d-flex align-items-center justify-content-between mb-2">
          <div
            class="spinner-border text-danger mx-auto"
            role="status"
          ></div>
        </div>}

       {!pending && !searching && savedFilter.length == 0 &&  <div className=" w-80  mx-auto  ptop">
            <div className=" d-flex flex-column align-items-center ptop">
              <h1 className="pb-3">You have no Report</h1>
              <p className="text-center pb-5">Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem iusto quas facere, repellat iste similique numquam error vitae earum animi reiciendis officia eligendi eum atque impedit libero quos commodi quasi!</p>
              <button className="pp py-3 border-0  btn_color text-white" onClick={()=>{
                history.push('/reportoverview/job-seeker/report')
              }}>Create Report</button>
            </div>
        </div> }

        {!pending && searching && <>
          <h1 className="mb-5">Saved Reports</h1>
          <div className=" rounded-lg overflow-hidden shadow-lg mt-5  ">
          <div className="d-flex align-items-center ">
            <form className="navbar-form navbar-left d-flex  w-100 justify-content-between bg-light align-items-center px-3 py-5">
              <h1 className="pt-2">Report Details</h1>

              <div className=" d-flex align-items-center ">
                <div className=" d-flex align-items-center   ">
                  <input
                    type="search"
                    onChange={(e) => {
                      e.persist();
                      setSearch(e.target.value);
                    }}
                    value={search}
                    className="form-control py-5 "
                    placeholder="Search"
                  />
                </div>
                
                <button
                  type="button"
                  onClick={()=>{
                    history.push('/reportoverview/job-seeker/report')
                  }}
                  className="rounded-sm px-5 py-2 border-0  btn_color text-white ml-3"
                >
                  Create Report
                </button>

                {/* <AddServices/> */}
              </div>
            </form>
          </div>

          <table class="table m-0">
            <thead className="bg-white">
              <tr className="">
                <th className="pl-5">Name</th>
                <th>Description</th>
                <th className="text-center">Date Of Creation</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-light ">
              {searchPending ? (
                <tr>
                  <td colSpan={4}>
                    <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                      <div
                        class="spinner-border text-danger mx-auto"
                        role="status"
                      ></div>
                    </div>
                  </td>
                </tr>
              ) : (
                savedFilter.map((item, index) => {
                  return (
                    <tr key={index} className="">
                      <td className="pl-5"><NavLink to={{
                        pathname: `/reportoverview/job-seeker/report?id=${item._id}`,
                        state: {id: item._id, filter: item}
                      }}>{ item.name }</NavLink></td>
                      <td className=" td2 text-truncate">{item.description}</td>
                      <td className="text-center">{moment(item.createdAt).format('MMMM DD, YYYY')}</td>
                      <td className=" d-flex justify-content-center">
                        <button className="btn btn-danger" 
                          onClick={()=>{
                            handleDeleteSavedFilter(item);
                          }}
                        >Delete</button>
                      </td>
                    </tr>
                  );
                })
              )}

              {!searchPending && savedFilter.length == 0 && (
                <tr>
                  <td align="center" colSpan={7}>
                    No Saved Filter Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        </>}
        
      </div>
    </Box>
  );
};

export default ReportingOverview;
